module.exports = __webpack_public_path__ + "static/media/noresult.33132c61.png";